export default __webpack_public_path__ + "static/media/profile.aa6a0044.svg";